import { initializeApp } from 'firebase/app'
import { getDatabase } from "firebase/database"
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth"

const firebaseConfig = {
    // apiKey: "AIzaSyA-ahyYw8KPIvjOzB7zqM04coOokY-c3l4",
    // authDomain: "coiffeur-expo.firebaseapp.com",
    // databaseURL: "https://coiffeur-expo-default-rtdb.europe-west1.firebasedatabase.app",
    // projectId: "coiffeur-expo",
    // storageBucket: "coiffeur-expo.appspot.com",
    // messagingSenderId: "180533241079",
    // appId: "1:180533241079:web:2db6f8fb50e3cd2e3fdff2",
    // measurementId: "G-QSMJQM6BG8"

    apiKey: "AIzaSyA55A3wWM6lPURxcQi0C4JPyXe7SOoA-hU",
    authDomain: "applysolution-mobile.firebaseapp.com",
    databaseURL: "https://applysolution-mobile-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "applysolution-mobile",
    storageBucket: "applysolution-mobile.appspot.com",
    messagingSenderId: "759410746602",
    appId: "1:759410746602:web:185503a84bea750092a393",
    measurementId: "G-MM6ERFV27X"
  }

const app = initializeApp(firebaseConfig)

// Get a reference to the database service
const database = getDatabase(app)

export default database

export const auth = getAuth(app)

